export default __webpack_public_path__ + "static/media/chem620.94e39206.svg";